module.exports = __webpack_public_path__ + "b652abf4056379dce47ceaa03ce84f52.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-instagram-black.svg
// module id = 1005
// module chunks = 69